import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const detectLanguage = () => {
  const saved = localStorage.getItem("teamup-lang");
  if (saved && translations[saved]) return saved;
  const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
  return translations[nav] ? nav : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLanguage);

  useEffect(() => {
    localStorage.setItem("teamup-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
